import { sortBy } from 'lodash-es';
import { Report, ConstantValues } from '../models/report.model';

/**
 *
 * @param {*} list ={}
 * return list of groups objects {groupName,ordinal,reports} with their reports
 */
const groupReports = (list = []) => {
  const groupedReports = {};
  list.forEach((report) => {
    // ungrouped just to be used as key but not in as group name
    const { name: groupName = 'ungrouped', ordinal = 999 } = report.group || {};
    if (groupName in groupedReports) {
      groupedReports[groupName].reports.push(new Report(report));
    } else {
      groupedReports[groupName] = {
        groupName: groupName !== 'ungrouped' ? groupName : '',
        ordinal,
        reports: [new Report(report)],
      };
    }
  });
  return Object.values(groupedReports);
};

export default class ReportingService {
  constructor(reportingAPI, attributesService, EquipmentService) {
    'ngInject';

    this.apiClient = reportingAPI;
    this.attributesService = attributesService;
    this.equipmentService = EquipmentService;
  }

  getGroupedReports() {
    return this.apiClient.getReportsList().then((res) => sortBy(groupReports(res.data), 'ordinal'));
  }

  getReportById(id) {
    return this.apiClient.getReportById(id).then((res) => new Report(res.data));
  }

  refresh() {
    return this.apiClient.refresh();
  }

  /**
   * @param {*} attrName
   * return list of { value , label }
   * will add 'All' option
   */
  getAttributeParamValidValues(attrName) {
    return this.attributesService.getAttributeValuesByName(attrName).then((values) => {
      // sort options then put 'All' in the top of the list
      const valuesWithoutAllOption = (values || []).filter((v) => v !== ConstantValues.All).sort();
      values = [ConstantValues.All, ...valuesWithoutAllOption];
      return values.map((val) => ({ value: val, label: val }));
    });
  }

  getKeyedDatapointsByAssetIds(assetIds) {
    // Datapoint visibility is checked in the inReach API level, no need to check in UI.
    return this.equipmentService.getSeriesByMultipleEquipment(assetIds).then((response) => {
      const { data: seriesData = [] } = response;

      const indexedSeries = seriesData.reduce((accumulator, series) => {
        const { dataId, title, descriptor: { title: descriptorTitle } = {} } = series;
        accumulator[dataId] = { ...series, title: descriptorTitle || title };
        return accumulator;
      }, {});

      return indexedSeries;
    });
  }

  getDatapointsAndFilter(assetIds, acceptableDatapoints = []) {
    return this.getKeyedDatapointsByAssetIds(assetIds).then((equipmentDatapoints) => {
      const datapointList = Object.values(equipmentDatapoints).filter((series) =>
        acceptableDatapoints.includes(series.dataId),
      );
      return datapointList;
    });
  }
}
